module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order",
    style: (_vm.bannerFlag ? 'margin-top: 56px;' : '')
  }, [_c('div', {
    staticClass: "order-box w",
    staticStyle: {
      "min-height": "calc(100vh - 125px)"
    }
  }, [_c('div', {
    staticClass: "order-step"
  }, _vm._l((_vm.stepList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "order-step-wrap",
      class: item.stepList.includes(_vm.currentStep + '') ? 'step-active' : ''
    }, [_c('i', {
      class: item.icon,
      staticStyle: {
        "font-size": "18px"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "calc(100vh - 220px)"
    },
    attrs: {
      "element-loading-text": "加载中...",
      "element-loading-background": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n        " + _vm._s(_vm.form.demName) + " " + _vm._s(_vm.catalogTitle) + " "), (_vm.currentStep != 1 && _vm.form.demPatient) ? _c('span', [_vm._v("【" + _vm._s(_vm.form.demPatient) + "】")]) : _vm._e()]), _vm._v(" "), (this.currentStep === 2) ? _c('div', {
    staticClass: "order-detail-design",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [_c('div', {
    staticClass: "order-basic-wrap"
  }, [_c('base-tag', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label": "基本信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-orthodontics el-input-contact spacing-height",
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.user.demServType != '00') ? _c('el-input', {
    staticClass: "input-form",
    style: ({
      '--inputColorContact': _vm.colorContact
    }),
    attrs: {
      "size": "mini"
    },
    on: {
      "input": _vm.change1
    },
    model: {
      value: (_vm.form.demContact),
      callback: function($$v) {
        _vm.$set(_vm.form, "demContact", $$v)
      },
      expression: "form.demContact"
    }
  }) : _c('el-input', {
    staticClass: "input-form",
    style: ({
      '--inputColorContact': _vm.colorContact
    }),
    attrs: {
      "size": "mini",
      "readonly": true
    },
    on: {
      "input": _vm.change1
    },
    model: {
      value: (_vm.form.demContact),
      callback: function($$v) {
        _vm.$set(_vm.form, "demContact", $$v)
      },
      expression: "form.demContact"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-orthodontics el-input-contact spacing-height"
  }, [_vm._m(1), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    style: ({
      '--inputColorPhone': _vm.colorPhone
    }),
    attrs: {
      "size": "mini"
    },
    on: {
      "input": _vm.change2
    },
    model: {
      value: (_vm.form.demPhone),
      callback: function($$v) {
        _vm.$set(_vm.form, "demPhone", $$v)
      },
      expression: "form.demPhone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-orthodontics el-input-contact spacing-height"
  }, [_vm._m(2), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    style: ({
      '--inputColorPatient': _vm.colorPatient
    }),
    attrs: {
      "size": "mini",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.change3
    },
    model: {
      value: (_vm.form.demPatient),
      callback: function($$v) {
        _vm.$set(_vm.form, "demPatient", $$v)
      },
      expression: "form.demPatient"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-orthodontics el-input-contact spacing-height"
  }, [_vm._m(3), _vm._v(" "), _c('el-select', {
    staticClass: "input-form",
    attrs: {
      "filterable": "",
      "placeholder": "请选择性别",
      "size": "mini"
    },
    model: {
      value: (_vm.form.demSex),
      callback: function($$v) {
        _vm.$set(_vm.form, "demSex", $$v)
      },
      expression: "form.demSex"
    }
  }, [_c('el-option', {
    staticClass: "option-item",
    attrs: {
      "label": "男",
      "value": "00"
    }
  }), _vm._v(" "), _c('el-option', {
    staticClass: "option-item",
    attrs: {
      "label": "女",
      "value": "99"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    ref: "age",
    staticClass: "input-age el-input-contact spacing-height"
  }, [_vm._m(4), _vm._v(" "), _c('el-select', {
    staticClass: "input-form",
    attrs: {
      "filterable": "",
      "placeholder": "请选择患者年龄",
      "size": "mini"
    },
    model: {
      value: (_vm.form.patientAge),
      callback: function($$v) {
        _vm.$set(_vm.form, "patientAge", $$v)
      },
      expression: "form.patientAge"
    }
  }, _vm._l((100), function(val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": val,
        "value": val
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.subCatalogId == '3010130' && _vm.currentStep === 2) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    staticClass: "makeCondition",
    attrs: {
      "label": "矫治需求"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "case-class"
  }, [_c('div', {
    staticClass: "case-class-box",
    staticStyle: {
      "margin-left": "1.3%",
      "line-height": "50px",
      "font-size": "15px",
      "width": "50%"
    }
  }, [_c('p', {
    staticClass: "case-class-item",
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', [_vm._v("矫治牙列")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    staticStyle: {
      "line-height": "50px",
      "width": "430px"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.countCalList)
      }
    },
    model: {
      value: (_vm.form.countCalList),
      callback: function($$v) {
        _vm.$set(_vm.form, "countCalList", $$v)
      },
      expression: "form.countCalList"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-right": "13.5%"
    },
    attrs: {
      "label": "00"
    }
  }, [_vm._v("上颌5-5")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-right": "13.5%"
    },
    attrs: {
      "label": "01"
    }
  }, [_vm._v("下颌5-5")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-right": "13.5%"
    },
    attrs: {
      "label": "02"
    }
  }, [_vm._v("上下颌5-5")])], 1)], 1)]), _vm._v(" "), _c('div', {
    ref: "rush",
    staticClass: "el-select-input spacing-height input-fac-rush",
    staticStyle: {
      "margin-left": "-20px"
    }
  }, [_vm._m(5), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "margin-left": "13px",
      "width": "130px"
    },
    attrs: {
      "controls-position": "right",
      "min": 0,
      "size": 'small',
      "disabled": _vm.isEditServOrder == '1' ? true : false
    },
    on: {
      "input": _vm.calAmount
    },
    model: {
      value: (_vm.form.orderRushFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderRushFee", $$v)
      },
      expression: "form.orderRushFee"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "totalPrice",
    staticClass: "spacing-height input-fac-cal-two",
    staticStyle: {
      "margin-left": "105px"
    }
  }, [_vm._m(6), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    style: ({
      '--inputColorOrderAmount': _vm.colorOrderAmount
    }),
    attrs: {
      "size": "mini",
      "readonly": true
    },
    model: {
      value: (_vm.form.orderAmount),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderAmount", $$v)
      },
      expression: "form.orderAmount"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "50px"
    }
  }, [(_vm.editCanvas || _vm.correctiveImages == '') ? _c('canvas-tooth', {
    attrs: {
      "correctiveImg": _vm.correctiveImages,
      "isCreate": _vm.isCreate
    },
    on: {
      "canvasImg": _vm.canvasToothImg,
      "ruleFlag": _vm.corrective
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.correctiveImages
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.editCanvas == false && _vm.correctiveImages != '') ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-right": "10%"
    },
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.editCanvas = !_vm.editCanvas
      }
    }
  }, [_vm._v("重新编辑")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('base-tag', {
    attrs: {
      "label": "其他要求"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 20
      },
      "placeholder": "请输入备注信息"
    },
    model: {
      value: (_vm.form.orderRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderRemark", $$v)
      },
      expression: "form.orderRemark"
    }
  })], 1)], 1), _vm._v(" "), (_vm.remarkHistory.length != 0) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "快捷标签"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-history"
  }, _vm._l((_vm.remarkHistory), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticStyle: {
        "margin": "5px 5px"
      },
      attrs: {
        "closable": ""
      },
      on: {
        "click": function($event) {
          return _vm.replaceStr(index)
        },
        "close": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.currentStep === 3) ? _c('div', {
    staticClass: "order-detail-upload",
    staticStyle: {
      "min-height": "calc(100vh - 413px)"
    }
  }, [(_vm.subCatalogId == '3010130' && _vm.currentStep === 3) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "临床检查信息与要求（非必填项）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dental-relationship"
  }, [_c('div', {
    staticClass: "molar-tooth"
  }, [_c('div', {
    staticClass: "molar-Str"
  }, [_vm._v("\n                磨牙关系\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "molar-select"
  }, [_c('p', {
    staticClass: "molar-select-item"
  }, [_c('span', {
    staticClass: "direction"
  }, [_vm._v("右侧")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.molarRelationShipRight)
      }
    },
    model: {
      value: (_vm.form.molarRelationShipRight),
      callback: function($$v) {
        _vm.$set(_vm.form, "molarRelationShipRight", $$v)
      },
      expression: "form.molarRelationShipRight"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "label": "01"
    }
  }, [_vm._v("I类")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "label": "02"
    }
  }, [_vm._v("II类")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "label": "03"
    }
  }, [_vm._v("III类")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "molar-select-item"
  }, [_c('span', {
    staticClass: "direction"
  }, [_vm._v("左侧")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.molarRelationShipLeft)
      }
    },
    model: {
      value: (_vm.form.molarRelationShipLeft),
      callback: function($$v) {
        _vm.$set(_vm.form, "molarRelationShipLeft", $$v)
      },
      expression: "form.molarRelationShipLeft"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "label": "01"
    }
  }, [_vm._v("I类")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "label": "02"
    }
  }, [_vm._v("II类")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "label": "03"
    }
  }, [_vm._v("III类")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "molar-tooth",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('div', {
    staticClass: "molar-Str"
  }, [_vm._v("尖牙关系")]), _vm._v(" "), _c('div', {
    staticClass: "molar-select"
  }, [_c('p', {
    staticClass: "molar-select-item"
  }, [_c('span', {
    staticClass: "direction"
  }, [_vm._v("右侧")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.canineRelationShipRight)
      }
    },
    model: {
      value: (_vm.form.canineRelationShipRight),
      callback: function($$v) {
        _vm.$set(_vm.form, "canineRelationShipRight", $$v)
      },
      expression: "form.canineRelationShipRight"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "label": "01"
    }
  }, [_vm._v("中性")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "label": "02"
    }
  }, [_vm._v("远中")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "03"
    }
  }, [_vm._v("近中")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "molar-select-item"
  }, [_c('span', {
    staticClass: "direction"
  }, [_vm._v("左侧")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.canineRelationShipLeft)
      }
    },
    model: {
      value: (_vm.form.canineRelationShipLeft),
      callback: function($$v) {
        _vm.$set(_vm.form, "canineRelationShipLeft", $$v)
      },
      expression: "form.canineRelationShipLeft"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "label": "01"
    }
  }, [_vm._v("中性")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "label": "02"
    }
  }, [_vm._v("远中")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "03"
    }
  }, [_vm._v("近中")])], 1)], 1)])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "case-class"
  }, [_c('div', {
    staticClass: "case-class-box",
    staticStyle: {
      "margin": "20px 0 0 2.5%",
      "line-height": "50px",
      "font-size": "15px"
    }
  }, [_c('p', {
    staticClass: "case-class-item",
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "letter-spacing": "2px"
    }
  }, [_vm._v("病例分类")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "molar-item-check",
    staticStyle: {
      "margin-left": "50px"
    },
    on: {
      "change": function($event) {
        return _vm.changeCaseClass()
      }
    },
    model: {
      value: (_vm.form.caseClass),
      callback: function($$v) {
        _vm.$set(_vm.form, "caseClass", $$v)
      },
      expression: "form.caseClass"
    }
  }, _vm._l((_vm.caseList), function(val, key) {
    return _c('el-checkbox', {
      key: key,
      staticClass: "item-check",
      attrs: {
        "label": '0' + key
      }
    }, [_vm._v(_vm._s(val.label))])
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "70px 0 30px 28px"
    }
  }, [_c('span', {
    staticClass: "title-Str",
    staticStyle: {
      "letter-spacing": "1px"
    }
  }, [_vm._v("牙列间隙")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "00"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.interdentalSpace)
      }
    },
    model: {
      value: (_vm.form.interdentalSpace),
      callback: function($$v) {
        _vm.$set(_vm.form, "interdentalSpace", $$v)
      },
      expression: "form.interdentalSpace"
    }
  }, [_vm._v("全部关闭")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "01"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.interdentalSpace)
      }
    },
    model: {
      value: (_vm.form.interdentalSpace),
      callback: function($$v) {
        _vm.$set(_vm.form, "interdentalSpace", $$v)
      },
      expression: "form.interdentalSpace"
    }
  }, [_vm._v("保留间隙")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.interdentalSpaceRemark),
      expression: "form.interdentalSpaceRemark"
    }],
    staticClass: "input-join",
    attrs: {
      "placeholder": "输入说明"
    },
    domProps: {
      "value": (_vm.form.interdentalSpaceRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "interdentalSpaceRemark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title-Str"
  }, [_vm._v("后牙反𬌗")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "00"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.toothRetroversion)
      }
    },
    model: {
      value: (_vm.form.toothRetroversion),
      callback: function($$v) {
        _vm.$set(_vm.form, "toothRetroversion", $$v)
      },
      expression: "form.toothRetroversion"
    }
  }, [_vm._v("保持")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "01"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.toothRetroversion)
      }
    },
    model: {
      value: (_vm.form.toothRetroversion),
      callback: function($$v) {
        _vm.$set(_vm.form, "toothRetroversion", $$v)
      },
      expression: "form.toothRetroversion"
    }
  }, [_vm._v("纠正")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dental-jaw",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('div', {
    staticClass: "jaw-Str"
  }, [_vm._v("中线")]), _vm._v(" "), _c('div', {
    staticClass: "dental-jaw"
  }, [_c('div', {
    staticStyle: {
      "line-height": "30px",
      "margin-left": "5px",
      "width": "60%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "30px"
    }
  }, [_vm._v("上颌")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "3.7%"
    },
    attrs: {
      "label": "00"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.centerUpper, 'centerUpper')
      }
    },
    model: {
      value: (_vm.form.centerUpper),
      callback: function($$v) {
        _vm.$set(_vm.form, "centerUpper", $$v)
      },
      expression: "form.centerUpper"
    }
  }, [_vm._v("保持")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "3%"
    },
    attrs: {
      "label": "01"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.centerUpper)
      }
    },
    model: {
      value: (_vm.form.centerUpper),
      callback: function($$v) {
        _vm.$set(_vm.form, "centerUpper", $$v)
      },
      expression: "form.centerUpper"
    }
  }, [_vm._v("改善")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("近中(+)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.centerUpperNearMid),
      expression: "form.centerUpperNearMid"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": _vm.form.centerUpper == '00',
      "name": "centerUpperNearMid",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.centerUpperNearMid)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "centerUpperNearMid", $event.target.value)
      }, _vm.filterNonDigits]
    }
  }), _vm._v("mm\n                "), _c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("远中(-)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.centerUpperFarAway),
      expression: "form.centerUpperFarAway"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": _vm.form.centerUpper == '00',
      "name": "centerUpperFarAway",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.centerUpperFarAway)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "centerUpperFarAway", $event.target.value)
      }, _vm.filterNonDigits]
    }
  }), _vm._v("mm\n              ")], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "30px"
    }
  }, [_vm._v("下颌")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "3.7%"
    },
    attrs: {
      "label": "00"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.centerDown, 'centerDown')
      }
    },
    model: {
      value: (_vm.form.centerDown),
      callback: function($$v) {
        _vm.$set(_vm.form, "centerDown", $$v)
      },
      expression: "form.centerDown"
    }
  }, [_vm._v("保持")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "3%"
    },
    attrs: {
      "label": "01"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.centerDown)
      }
    },
    model: {
      value: (_vm.form.centerDown),
      callback: function($$v) {
        _vm.$set(_vm.form, "centerDown", $$v)
      },
      expression: "form.centerDown"
    }
  }, [_vm._v("改善")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("近中(+)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.centerDownNearMid),
      expression: "form.centerDownNearMid"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": _vm.form.centerDown == '00',
      "name": "centerDownNearMid",
      "type": "number",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.centerDownNearMid)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "centerDownNearMid", $event.target.value)
      }, _vm.filterNonDigits]
    }
  }), _vm._v("mm\n                "), _c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("远中(-)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.centerDownFarAway),
      expression: "form.centerDownFarAway"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": _vm.form.centerDown == '00',
      "name": "centerDownFarAway",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.centerDownFarAway)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "centerDownFarAway", $event.target.value)
      }, _vm.filterNonDigits]
    }
  }), _vm._v("mm\n              ")], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "5%",
      "line-height": "30px"
    }
  }, [_c('div', [_c('span', {
    staticClass: "title-Str"
  }, [_vm._v("覆𬌗")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "00"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.coverUp, 'coverUp')
      }
    },
    model: {
      value: (_vm.form.coverUp),
      callback: function($$v) {
        _vm.$set(_vm.form, "coverUp", $$v)
      },
      expression: "form.coverUp"
    }
  }, [_vm._v("保持")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "01"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.coverUp)
      }
    },
    model: {
      value: (_vm.form.coverUp),
      callback: function($$v) {
        _vm.$set(_vm.form, "coverUp", $$v)
      },
      expression: "form.coverUp"
    }
  }, [_vm._v("改善")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.coverUpParam),
      expression: "form.coverUpParam"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": _vm.form.coverUp == '00',
      "name": "coverUpParam",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.coverUpParam)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "coverUpParam", $event.target.value)
      }, _vm.filterNonDigits]
    }
  }), _vm._v("mm\n              ")], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "title-Str"
  }, [_vm._v("覆盖")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "00"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.cover, 'cover')
      }
    },
    model: {
      value: (_vm.form.cover),
      callback: function($$v) {
        _vm.$set(_vm.form, "cover", $$v)
      },
      expression: "form.cover"
    }
  }, [_vm._v("保持")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "01"
    },
    on: {
      "change": function($event) {
        return _vm.changeMolar(_vm.form.cover)
      }
    },
    model: {
      value: (_vm.form.cover),
      callback: function($$v) {
        _vm.$set(_vm.form, "cover", $$v)
      },
      expression: "form.cover"
    }
  }, [_vm._v("改善")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.coverParam),
      expression: "form.coverParam"
    }],
    staticStyle: {
      "border-bottom": "1px solid black",
      "background": "#F7F7F7",
      "width": "75px",
      "text-align": "center"
    },
    attrs: {
      "readonly": _vm.form.cover == '00',
      "name": "coverParam",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.coverParam)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "coverParam", $event.target.value)
      }, _vm.filterNonDigits]
    }
  }), _vm._v("mm\n              ")], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 4) ? _c('div', {
    staticClass: "order-detail-upload",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [_c('base-tag', {
    attrs: {
      "label": "隐形矫治",
      "fontSize": 25 + 'px'
    }
  }), _vm._v(" "), _c('templateUpload', {
    attrs: {
      "list": _vm.list1,
      "currentStep": _vm.currentStep,
      "dataType": '22'
    },
    on: {
      "transFile": _vm.portraitFile
    }
  }), _vm._v(" "), _c('templateUpload', {
    attrs: {
      "list": _vm.list2,
      "currentStep": _vm.currentStep,
      "dataType": '09'
    },
    on: {
      "transFile": _vm.portraitFile
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 5) ? _c('div', {
    staticClass: "order-detail-upload",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [_c('base-tag', {
    attrs: {
      "label": "隐形矫治",
      "fontSize": 25 + 'px'
    }
  }), _vm._v(" "), _c('boneUploadImg', {
    attrs: {
      "list": _vm.list1,
      "currentStep": _vm.currentStep,
      "dataType": '23'
    },
    on: {
      "transFile": _vm.portraitFile
    }
  }), _vm._v(" "), _c('modelUpload', {
    attrs: {
      "list": _vm.list2,
      "currentStep": _vm.currentStep,
      "dataType": '07'
    },
    on: {
      "transFile": _vm.portraitFile
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentStep === 6) ? _c('div', {
    staticClass: "order-detail-upload",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [_c('base-tag', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label": "隐形矫治",
      "fontSize": 25 + 'px'
    }
  }), _c('span', {
    staticStyle: {
      "position": "absolute",
      "left": "9%",
      "top": "15px",
      "color": "#409EFF"
    }
  }, [_vm._v(" (非必填项)")]), _vm._v(" "), _c('modelUpload', {
    attrs: {
      "list": _vm.list1,
      "currentStep": _vm.currentStep,
      "dataType": '10'
    },
    on: {
      "transFile": _vm.portraitFile
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '3010130') ? _c('div', {
    staticClass: "order-ops"
  }, [(_vm.currentStep === 2) ? _c('y-button', {
    attrs: {
      "text": "重新创建",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.clickReSelect
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep !== 2 && _vm.currentStep != 1) ? _c('y-button', {
    attrs: {
      "text": "上一步",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.clickPreStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep != 6) ? _c('y-button', {
    attrs: {
      "text": "下一步",
      "classStyle": _vm.subCatalogId == '3010130' ? 'main-btn ml' : 'disabled-btn ml'
    },
    on: {
      "btnClick": _vm.clickNextStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 6 || _vm.isEditServOrder == '1') ? _c('y-button', {
    attrs: {
      "text": _vm.isEditServOrder == '1' ? '修改提交' : '生成订单',
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.submitUpdate
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('Customer', {
    staticClass: "customerSer"
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": "",
      "title": "进度留言",
      "width": "30%",
      "visible": _vm.msgDialog,
      "modal-append-to-body": false,
      "destroy-on-close": true,
      "lock-scroll": false
    },
    on: {
      "update:visible": function($event) {
        _vm.msgDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "left",
      "model": _vm.ruleForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "content",
      "label": "留言内容:",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "请填写留言内容内容"
    },
    model: {
      value: (_vm.ruleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "content", $$v)
      },
      expression: "ruleForm.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.msgDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("继续制作")])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("下单名称")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("联系方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("患者姓名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("患者性别")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("年龄")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("是否加急(元)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("总价")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b0ce268","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/orthodonticsOrder/orthodonticsCreateOrder.vue
// module id = 657
// module chunks = 0